import React from 'react';
import { seconds, answeredPct } from '../../utils/overview';

// Cómo le fue al motor en las últimas 24 horas. Sin mensajes no se inventan promedios: se dice que no hubo.
const Tile = ({ label, value, sub, tone }) => (
  <div className="rounded-2xl bg-raised/60 px-4 py-3.5">
    <p className="text-[12.5px] font-medium text-fg-dim">{label}</p>
    <p className={`mt-1 font-display text-[28px] leading-none font-bold tabular-nums ${tone === 'signal' ? 'text-signal' : 'text-fg'}`}>{value}</p>
    {sub && <p className="mt-1.5 text-[12px] text-fg-faint">{sub}</p>}
  </div>
);

export default function HealthCard({ engine, cost }) {
  const none = !engine || engine.total === 0;
  const pct = answeredPct(engine);
  return (
    <section aria-label="Últimas 24 horas del motor" className="rounded-3xl bg-panel ring-1 ring-line p-5 sm:p-6" style={{ boxShadow: 'var(--shadow)' }}>
      <div className="flex items-baseline justify-between gap-3 mb-4">
        <h2 className="font-display text-[18px] font-bold text-fg">Últimas 24 horas</h2>
        <p className="text-[12.5px] text-fg-faint">Mensajes que atendió el motor propio</p>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        <Tile label="Atendidos" value={none ? '—' : engine.total.toLocaleString('es-MX')} sub={none ? 'Ninguno en 24 horas' : `${engine.ok} respondidos · ${engine.ignored} sin responder`} />
        <Tile label="Respondidos" value={pct === null ? '—' : `${pct}%`} sub={none ? undefined : 'del total atendido'} />
        <Tile label="Tiempo de respuesta" value={seconds(engine?.avg_ms)} sub={engine?.p95_ms != null ? `el 95 % en menos de ${seconds(engine.p95_ms)}` : undefined} />
        <Tile label="Con error" value={none ? '—' : engine.error.toLocaleString('es-MX')} tone={engine?.error > 0 ? 'signal' : undefined} sub={none ? undefined : engine.error > 0 ? 'Mira la actividad del agente' : 'Ninguno'} />
      </div>
      {!none && cost != null && <p className="mt-3 text-[12.5px] text-fg-faint">Gasto de IA en 24 horas: <b className="text-fg-dim">US${Number(cost).toFixed(Number(cost) < 0.01 ? 4 : 2)}</b></p>}
    </section>
  );
}
